import { render, staticRenderFns } from "./NotaExameEspecial.vue?vue&type=template&id=6e05c61e&"
import script from "./NotaExameEspecial.vue?vue&type=script&lang=js&"
export * from "./NotaExameEspecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports